import React, { useEffect, useState } from 'react';
import { Text, Button, Row, FlexView, Col, Separator } from '@cuemath/comps';
import { COLORS } from '@cuemath/comps';
import { useDispatch } from 'react-redux';
import styled from 'styled-components';
import { Message } from 'modules/form';
import { COUNTRY_OPTIONS } from 'utils';
import { Input, Asterisk, Label, SelectInput } from 'modules/form';
import { closeModal } from 'actions/modal';
import { useAssignTeacherPatch } from 'actions/assign-teacher';

const Wrapper = styled.div`
  padding: 40px 10px 20px;
`;

export const SelectInputWrapper = styled(SelectInput)`
  width: 140px;
  height: 40px;
  padding: 5px 10px;
  outline: none;
  display: inline-block;
  &:focus {
    border: 3px solid #c4dffe;
    &::placeholder {
      opacity: 0;
    }
  }
`;

let timeout = null;

const AssignTeacherToLead = ({ student }) => {
  const dispatch = useDispatch();
  const [form, setForm] = useState({ phone: '', countryCode: '' });
  const { phone: teacherPhone, countryCode: teacherCountryCode } = form || {};
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);
  const { student_service_id: studentServiceId, parent_service_id: parentServiceId } =
    student || {};

  useEffect(() => {
    return () => {
      clearTimeout(timeout);
      timeout = null;
    };
  });

  const onAssignTeacherPatchComplete = (errorMsg, data) => {
    const { enquiry } = data || {};
    const { teacher_id: teacherId } = enquiry || {};

    if (teacherId) {
      setSuccess('Teacher assigned successfully.');
      setTimeout(() => dispatch(closeModal()), 2000);
    } else {
      setError(errorMsg || 'something went wrong');
    }
  };

  const { patch: assignTeacherPatch, isProcessing } = useAssignTeacherPatch({
    onComplete: onAssignTeacherPatchComplete,
  });

  const onChange = value => {
    if (value.length > 13) return;
    setForm(prev => ({ ...prev, phone: value }));
  };

  const changeExtension = selectedCountry => {
    setForm(prev => ({ ...prev, countryCode: selectedCountry.value }));
  };

  const onConfirm = () => {
    setError('');
    const payload = {
      parent_service_id: parentServiceId,
      teacher_phone: teacherPhone,
      teacher_country_code: teacherCountryCode,
    };

    assignTeacherPatch(studentServiceId, payload);
  };

  const isDisabled = isProcessing || !teacherPhone || !teacherCountryCode;

  return (
    <Wrapper>
      <Text color={COLORS.GREEN} size="large" weight="bolder" align="center">
        Assign Classroom Teacher to Lead
      </Text>
      <Separator height={16} transparent />
      <Row alignItems="center">
        <Col>
          <Label style={{ width: '200px' }}>
            {'Phone Number'}
            <Asterisk>*</Asterisk>
          </Label>
        </Col>
        <Row alignItems="center">
          <SelectInputWrapper
            name="countryCode"
            onChange={changeExtension}
            options={COUNTRY_OPTIONS}
          />
          <Input
            style={{ width: '240px' }}
            name={'phone'}
            placeholder={'Enter the Phone No.'}
            type="number"
            required={true}
            value={form.phone}
            onChange={onChange}
          />
        </Row>
      </Row>
      <Separator height={16} transparent />
      <FlexView flexDirection="row" justifyContent="center" alignItems="center">
        {success ? (
          <Message width="100%">{success}</Message>
        ) : (
          <Button
            align="center"
            label="Submit"
            onClick={onConfirm}
            disabled={isDisabled}
          />
        )}
      </FlexView>
      {error && (
        <Message width="100%" error>
          {error}
        </Message>
      )}
    </Wrapper>
  );
};

export default AssignTeacherToLead;
